import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import cn from 'classnames/bind';
import 'react';
import 'classnames';
import '../../Icons/ArrowDown/index.js';
import '../../Icons/Camera/index.js';
import '../../Icons/Category/index.js';
import '../../Icons/CheckCircle/index.js';
import '../../Icons/Close/index.js';
import '../../Icons/Favorite/index.js';
import '../../Icons/Lens/index.js';
import '../../Icons/LensHeart/index.js';
import '../../Icons/Phone/index.js';
import '../../Icons/Pin/index.js';
import '../../Icons/Promo/index.js';
import '../../Icons/Share/index.js';
import '../../Icons/Bell/index.js';
import '../../Icons/Bin/index.js';
import '../../Icons/Check/index.js';
import '../../Icons/TriangleExclamation/index.js';
import '../../Icons/ShoppingBag/index.js';
import '../../UIElements/Button/index.js';
import { Tooltip } from '../../UIElements/Tooltip/Tooltip/index.js';
import { TooltipIcon } from './TooltipIcon.js';
import classes from './index.module.scss.js';

const cx = cn.bind(classes);
const InputHeader = ({ name, label, rightLabel, secondaryLabel, tooltip, style = 'default', }) => {
    if (!label && !rightLabel && !secondaryLabel && !tooltip) {
        return jsx(Fragment, {});
    }
    return (jsx("div", { className: cx('cactus-input-header__wrapper'), children: jsxs("div", { className: cx('input-header', `style-${style}`), children: [jsxs("div", { children: [label && (jsx("label", { htmlFor: name, className: cx('label'), children: label })), secondaryLabel && (jsx("span", { className: cx('secondary-label', 'size-small', 'weight-book'), children: secondaryLabel })), tooltip && (jsx(Tooltip, { ...tooltip, arrowPosition: tooltip.arrowPosition ?? 'left-center', classes: [...(tooltip.classes ?? []), cx('tooltip')], children: TooltipIcon }))] }), rightLabel && (jsx("span", { className: cx('right-label', 'weight-book'), children: rightLabel }))] }) }));
};

export { InputHeader };
//# sourceMappingURL=index.js.map
